import httpClient from "../http";

export const searchApi = {
  universalSearch: (query) => httpClient.post("/search/universal", { query }),
};
